/**
 * Markaii subscription plan definitions — frontend copy.
 *
 * Single source of truth used by Landing (public pricing section),
 * Billing (in-app subscribe + upgrade cards), and the UserMenu trial badge.
 *
 * Keep in sync with api/src/config/billing.js (the backend source of truth).
 * The display prices (priceMonthly / priceAnnual) and features lists must
 * match the backend config so users don't see drift between the marketing
 * page and the Stripe Checkout.
 */

/**
 * Plan tier ordering — higher = more features. Mirrors PLAN_TIER_ORDER
 * in api/src/config/billing.js. Used by the Billing page to filter
 * which plans are valid upgrades from the current tier.
 */
export const PLAN_TIER_ORDER = {
  trial: 0, solo: 1, pro: 2, agency: 3, enterprise: 4, internal: 99,
};

export const PLANS = [
  {
    tier:         'solo',
    name:         'Solo',
    priceMonthly: 79,
    priceAnnual:  790,
    saveAnnual:   'Save $158 — 2 months free',
    blurb:        'For solo founders launching their first brand.',
    recommended:  false,
    features:     ['1 brand', '100 posts / month', '3 social accounts', '200 AI calls / day'],
    // Legacy display shape used by Landing page (price string + sub-label)
    monthly: { price: '$79',    sub: '/ month' },
    annual:  { price: '$790',   sub: '/ year', save: 'Save $158 — 2 months free' },
  },
  {
    tier:         'pro',
    name:         'Pro',
    priceMonthly: 249,
    priceAnnual:  2490,
    saveAnnual:   'Save $498 — 2 months free',
    blurb:        'For SaaS founders running a portfolio of brands.',
    recommended:  true,
    features:     ['3 brands', '300 posts / month', '9 social accounts', '600 AI calls / day'],
    monthly: { price: '$249',   sub: '/ month' },
    annual:  { price: '$2,490', sub: '/ year', save: 'Save $498 — 2 months free' },
  },
  {
    tier:         'agency',
    name:         'Agency',
    priceMonthly: 599,
    priceAnnual:  5990,
    saveAnnual:   'Save $1,198 — 2 months free',
    blurb:        'For agencies managing client brands at scale.',
    recommended:  false,
    features:     ['10 brands', '1,000 posts / month', '30 social accounts', '2,000 AI calls / day'],
    monthly: { price: '$599',   sub: '/ month' },
    annual:  { price: '$5,990', sub: '/ year', save: 'Save $1,198 — 2 months free' },
  },
];
